import { render, staticRenderFns } from "./BudgetPreviewCost.vue?vue&type=template&id=68097b0e&scoped=true&"
import script from "./BudgetPreviewCost.vue?vue&type=script&lang=ts&"
export * from "./BudgetPreviewCost.vue?vue&type=script&lang=ts&"
import style0 from "./BudgetPreviewCost.vue?vue&type=style&index=0&id=68097b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68097b0e",
  null
  
)

export default component.exports